import { render, staticRenderFns } from "./PhotoUpload.vue?vue&type=template&id=1012e66e"
import script from "./PhotoUpload.vue?vue&type=script&lang=js"
export * from "./PhotoUpload.vue?vue&type=script&lang=js"
import style0 from "./PhotoUpload.vue?vue&type=style&index=0&id=1012e66e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports